import React from "react";
import {
  VideoCamera,
  WhatsappLogo,
  TelegramLogo,
  Coin,
  ChartPieSlice,
  Calendar,
  FileArrowDown,
  UsersThree,
} from "@phosphor-icons/react";

const ITEMS = [
  {
    icon: VideoCamera,
    title: "Live Trading Support",
    body: "Live support 3 days a week. Levels, plans, entries, exits — in real time.",
    big: true,
  },
  {
    icon: WhatsappLogo,
    title: "Batch WhatsApp Group",
    body: "Session links, doubts, index levels and options table for study (Nifty / Bank Nifty / Midcap).",
  },
  {
    icon: Coin,
    title: "MCX Live",
    body: "MCX live 2 days a week. Observe first, execute later.",
  },
  {
    icon: TelegramLogo,
    title: "Telegram Recordings",
    body: "Every live session uploaded. Revise anytime. Never miss a class.",
  },
  {
    icon: ChartPieSlice,
    title: "Previous Batch Recordings",
    body: "Full access to past batch recordings. Self-paced revision whenever you need it.",
  },
  {
    icon: Calendar,
    title: "EOD Learning Sessions",
    body: "Short ~10 min level-drawing routine. Build muscle memory. Recordings included.",
  },
  {
    icon: UsersThree,
    title: "Monthly 1-on-1 Slot",
    body: "Personalised P&L review and setup-compatibility audit, every single month.",
  },
  {
    icon: FileArrowDown,
    title: "GoCharting Templates",
    body: "Pre-built templates so your charts are ready on day one.",
  },
];

export default function WhatsIncluded() {
  return (
    <section
      data-testid="included-section"
      id="included"
      className="bg-[#0A0A0A] text-[#F4F3ED] py-20 lg:py-28 border-b border-[#0A0A0A]"
    >
      <div className="max-w-[1320px] mx-auto px-5 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10">
          <div>
            <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E] mb-4">
              05 / WHAT'S INCLUDED
            </div>
            <h2 className="font-display font-black text-4xl lg:text-6xl tracking-tighter leading-[0.95]">
              A full
              <br />
              ecosystem.
              <br />
              Not just a course.
            </h2>
          </div>
          <p className="font-body text-[#A1A1AA] max-w-md">
            You don't just buy lectures. You're plugged into a working trading
            community for 6 months — and the community stays with you after.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-[#2A2A2A] border border-[#2A2A2A]">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            const span = it.big ? "md:col-span-2 md:row-span-2" : "md:col-span-1";
            return (
              <div
                key={i}
                data-testid={`included-${i}`}
                className={`bg-[#0A0A0A] p-7 lg:p-8 ${span} group hover:bg-[#141414] transition-colors flex flex-col`}
              >
                <div className="flex items-start justify-between mb-5">
                  <Icon
                    size={it.big ? 36 : 26}
                    weight="duotone"
                    className="text-[#D9381E]"
                  />
                  <span className="font-mono-acc text-[10px] tracking-[0.25em] text-[#A1A1AA]">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3
                  className={`font-display font-black tracking-tight mb-2 ${
                    it.big ? "text-3xl lg:text-4xl" : "text-lg"
                  }`}
                >
                  {it.title}
                </h3>
                <p
                  className={`font-body text-[#A1A1AA] leading-relaxed ${
                    it.big ? "text-base" : "text-sm"
                  }`}
                >
                  {it.body}
                </p>
                {it.big && (
                  <div className="mt-auto pt-6">
                    <span className="font-mono-acc text-[10px] tracking-[0.3em] text-[#D9381E] uppercase">
                      ● Every market day
                    </span>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-6 border border-[#2A2A2A] bg-[#0E0E0E] p-6 flex flex-col md:flex-row md:items-center gap-4">
          <span className="font-mono-acc text-[10px] tracking-[0.3em] text-[#D9381E] uppercase">
            ⚠ Important
          </span>
          <p className="font-body text-sm text-[#A1A1AA]">
            For the <span className="text-[#F4F3ED] font-semibold">first 2 months</span>, do not execute trades from shared levels. Just watch, compare and learn. Patience is part of the curriculum.
          </p>
        </div>
      </div>
    </section>
  );
}
